export const ABOUT_INFO_DESCRIPTIONS = [
  {
    name: 'Work of Artist',
    value: 'Work of Artist',
    description: `Work of Artist refers to artworks represented by the Gallery but owned by the Artist. Once an artwork is uploaded and accepted, Artists can claim their profiles and access exclusive features.\nThis ensures that both Galleries and Artists maintain their respective roles while maximizing opportunities on the platform.`
  },
  {
    name: 'Gallery Owned',
    value: 'Gallery owned',
    description: `Gallery Owned artworks are those previously purchased and now owned by the Gallery.

      For these artworks, no information is shared with the Artist. However, if the Artist has a profile on Suarte, the artwork will automatically appear in their profile.`
  },
  {
    name: 'Artist',
    description: 'To add an Artist on Suarte, first search for their name and select it. If the artist is not listed, click on "Create new artist profile" and provide the necessary information.'
  },
  {
    name: 'Title',
    description: `We recommend choosing a descriptive title for the artwork, as this can have a significant impact on its visibility. Avoid using "Untitled" unless it's necessary.`
  },
  {
    name: 'Description',
    description: `Provide a detailed description that helps potential buyers connect with the artwork. You may include its inspiration, meaning, and creative process to make it more compelling.\nA well-crafted description enhances search visibility, making it easier for collectors to discover the piece.`
  }, 
  {
    name: 'Medium',
    description: `Specify the mediums/materials used to create the artwork. Feel free to add further details in the description.`
  },
  {
    name: 'Theme',
    description: `Select the artwork's central theme. If it explores multiple themes, you may add up to three, ordered by dominance: 1 as the most dominant, followed by 2 and 3.`
  },
  {
    name: 'Color',
    description: `Identify the artwork's dominant color. If the artwork features multiple principal colors, you may add up to three, ordered by dominance: 1 as the most dominant, followed by 2 and 3.`
  },
  {
    name: 'Emotion',
    description: `Highlight the primary emotion the artwork triggers. If the artwork evokes multiple emotions, you may add up to three, ordered by dominance: 1 as the most dominant, followed by 2 and 3.`
  },
  {
    name: 'Year of Creation',
    description: `Specify the artwork's creation year, or if applicable, a range (e.g., 2022-2024).`
  },
  {
    name: 'Dimensions',
    description: `List the precise dimensions of the artwork in centimeters or inches, not including the frame.`
  },
  {
    name: 'Price',
    description: `Provide the artwork's price. Remember, the gallery can adjust the artwork price at any time. However, the new price cannot be lower than 30% of the uploading price.`
  },
  {
    name: 'Limited Editions',
    description: `Limited Editions are museum-quality prints produced and distributed by Suarte with the legal representative's consent. They offer Galleries and Artists a way to broaden their audience and generate passive income while providing art lovers with an affordable entry point to start their collection.\nSuarte evaluates the artwork's characteristics and pictures once a request is made to determine the viability of producing Limited Edition prints. For more details, visit Suarte Limited Editions.` 
  },
];